/* Central overlay lock — toggles html.zeus-overlay-open when any takeover UI is active.
   Used to hide chat, sticky nav, pack edge tab, etc. while drawers/menus/modals are open. */
(function () {
  "use strict";

  var LOCK_CLASS = "zeus-overlay-open";
  var DECISION_CLASS = "zeus-decision-context";

  function isTakeoverLocked() {
    return (
      !!document.querySelector(".drawer[open]") ||
      !!document.querySelector("#zeus-shop-overlay.is-open") ||
      !!document.querySelector("#zeus-mega-menu.is-open") ||
      !!document.querySelector("[data-zeus-modal-overlay].is-open") ||
      !!document.querySelector(".zeus-ecosystem__sheet-backdrop.is-active") ||
      document.body.classList.contains("zeus-ecosystem-sheet-open") ||
      !!document.querySelector("[data-bsel-modal].is-open") ||
      !!document.querySelector("[data-bsel-decline-overlay].is-open")
    );
  }

  function isDecisionContext() {
    return (
      isTakeoverLocked() ||
      document.body.classList.contains("template-product") ||
      document.body.classList.contains("template-cart") ||
      /(^|\/)pages\/zeus-board-selector\/?$/.test(window.location.pathname)
    );
  }

  function isLocked() {
    return isTakeoverLocked() || document.documentElement.classList.contains("zeus-klaviyo-popup-open");
  }

  var legacyFloatingUiTagged = false;

  function tagLegacyFloatingUi() {
    if (legacyFloatingUiTagged) return;
    document.querySelectorAll("button, a").forEach(function (el) {
      if (el.hasAttribute("data-zeus-floating-ui")) return;
      var label = (el.textContent || "").replace(/\s+/g, " ").trim();
      if (!/^LEASH\s*\?$/i.test(label)) return;
      var style = window.getComputedStyle(el);
      if (style.position !== "fixed" && style.position !== "sticky") return;
      el.setAttribute("data-zeus-floating-ui", "true");
      el.setAttribute("data-zeus-pack-edge-tab", "true");
      legacyFloatingUiTagged = true;
    });
  }

  var lockRafPending = false;

  function syncOverlayLock() {
    if (lockRafPending) return;
    lockRafPending = true;
    requestAnimationFrame(function () {
      lockRafPending = false;
      var shouldLock = isLocked();
      var shouldSuppressPopup = isDecisionContext();
      /* Skip the toggle if the state is already correct to avoid triggering
         the MutationObserver on the class change we just made. */
      if (document.documentElement.classList.contains(LOCK_CLASS) !== shouldLock) {
        document.documentElement.classList.toggle(LOCK_CLASS, shouldLock);
      }
      if (document.documentElement.classList.contains(DECISION_CLASS) !== shouldSuppressPopup) {
        document.documentElement.classList.toggle(DECISION_CLASS, shouldSuppressPopup);
        document.dispatchEvent(new CustomEvent("zeus:decision-context-change"));
      }
    });
  }

  window.ZeusOverlayLock = {
    sync: syncOverlayLock,
    isLocked: isLocked,
    isDecisionContext: isDecisionContext,
  };

  function init() {
    tagLegacyFloatingUi();
    syncOverlayLock();

    /* Narrow to attribute mutations only (no childList/subtree) — we watch
       class/open/hidden on any element in the document. childList/subtree
       is not needed because isLocked() reads class attributes, not node
       presence. Excluding childList also prevents the observer from firing
       on every DOM insertion, which was the main source of re-entrancy. */
    var lockObserver = new MutationObserver(syncOverlayLock);
    lockObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class", "open", "hidden"],
      subtree: true,
    });

    var tagObserver = new MutationObserver(function (mutations) {
      if (legacyFloatingUiTagged) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) {
            tagLegacyFloatingUi();
            if (legacyFloatingUiTagged) return;
          }
        }
      }
    });
    tagObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
